import styled from 'styled-components'
import { STATUS } from '../../../../const/status'
import { colors, derivedColors } from '../../../../const'

export const QualityBadge = styled.div`
  position: absolute;
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $align, $offset }) => ($align === 'left' ? `${$offset}px` : 'auto')};
  right: ${({ $align, $offset }) => ($align === 'right' ? `${$offset}px` : 'auto')};
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: ${({ $status }) => {
    return STATUS[$status] || derivedColors.attenuated
  }};
  color: ${colors.textPrimary};
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  white-space: nowrap;

  svg {
    width: 14px;
    height: 14px;
  }
`
